import { PurchaseProduct } from './types';

type CreatePurchaseProductType = {
  product: any;
  category: string;
  list: string;
};

//Ticari Krediler
export const createPurchaseSmeRecourseProduct = async ({ product, category, list }: CreatePurchaseProductType): Promise<PurchaseProduct> => {
  return {
    name: `${product.bankName} ${product.productName}`,
    id: String(product.id),
    price: product.defaultAmount,
    brand: product.bankName,
    category: category,
    list: list,
    position: product.displayOrder ?? 1,
    quantity: product.quantity ?? 1,
    metric1: product.metrics?.metric1,
    metric2: product.metrics?.metric2,
    metric3: product.metrics?.metric3,
    metric4: product.metrics?.metric4,
    metric5: product.metrics?.metric5,
    metric6: product.metrics?.metric6,
    metric7: product.metrics?.metric7,
    dimension9: product.dimensions?.dimension9 ? 'Evet' : 'Hayır',
    dimension1: String(product.dimensions?.dimension1),
    dimension2: String(product.dimensions?.dimension2),
    dimension3: String(product.dimensions?.dimension3),
    dimension4: String(product.dimensions?.dimension4),
    dimension5: String(product.dimensions?.dimension5),
    dimension6: String(product.dimensions?.dimension6),
    dimension7: String(product.dimensions?.dimension7),
  };
};

//Kredi Kartı
export const createPurchaseCreditCartRecourseProduct = async ({
  product,
  category,
  list,
}: CreatePurchaseProductType) => {
  return {
    name: `${product.bankName} ${product.productName}`,
    id: String(product.id),
    price: product.defaultAmount,
    brand: product.brand,
    category: category,
    list: list,
    position: product.displayOrder ?? 1,
    quantity: product.quantity ?? 1,
    metric8: product.metrics?.metric8,
    dimension8: String(product.dimensions?.dimension8),
  };
};

//Maaş Promosyon
export const createPurchasePromotionsRecourseProduct = async ({
  product,
  category,
  list,
}: CreatePurchaseProductType) => {
  return {
    name: product.productName,
    id: `maas_${product.id}`,
    price: product.defaultAmount,
    brand: product.productName,
    category: category,
    list: list,
    position: product.displayOrder ?? 1,
    quantity: product.quantity ?? 1,
    variant: Object.keys(product.applyBanks ?? []).join('_'),
  };
};

//Pos Ürünleri
export const createPurchasePosRecourseProduct = ({ product, category, list }: CreatePurchaseProductType) => {
  return {
    name: `${product.bankName} ${product.productName}`,
    id: product.id,
    price: product.defaultAmount,
    brand: product.bankName,
    category: category,
    list: list,
    position: product.displayOrder ?? 1,
    quantity: product.quantity ?? 1,
    metric1: product.metrics?.metric1,
    metric2: product.metrics?.metric2,
    dimension1: String(product.dimensions?.dimension1),
    dimension2: String(product.dimensions?.dimension2),
    dimension9: product.dimensions?.dimension9 ? 'Evet' : 'Hayır',
  };
};

//Çek Gönder
export const createPurchaseChequeRecourseProduct = ({ product, category, list }: CreatePurchaseProductType) => {
  return {
    name: product.productName,
    id: `cek_${product.id}`,
    price: product.defaultAmount,
    brand: 'Cek Gonder',
    category: category,
    list: list,
    position: product.displayOrder ?? 1,
    quantity: product.quantity ?? 1,
    dimension10: product.dimensions?.dimension10,
    variant: Object.keys(product.applyBanks ?? []).join('_'),
  };
};

//DOB
export const createPurchaseDOBRecourseProduct = async ({ product, category, list }: CreatePurchaseProductType) => {
  return {
    name: `${product.bankName} ${product.productName}`,
    id: String(product.id),
    price: product.defaultAmount,
    brand: product.bankName,
    category: category,
    list: list,
    position: product.displayOrder ?? 1,
    quantity: product.quantity ?? 1,
    dimension9: product.dimensions?.dimension9 ? 'Evet' : 'Hayır',
  };
};